import { Stat } from './Stat';
import { UserStatEntryType } from './UserStatEntryType';
import { ClientType } from '../gameClient/clientType';
import { getBrowserName } from '../utils/browser';
import { RealCurrentUser } from '../general/modules/user/realCurrentUser';
import { newLoaderClientFactsMap, NewLoaderFacts } from '../gameClient/webgl/new-loader-facts';
import { AxiosResponse } from 'axios';

const DEFAULT_COUNT = 1;

export async function sendClientPreloaderProgressFact(percents: number, msSinceStart: number, startTs: number) {
    const cprops = [ClientType.WEBGL, getBrowserName()];
    const iprops = [percents, msSinceStart, startTs];

    return Stat.sendEvent(UserStatEntryType.client_preloader_progress, DEFAULT_COUNT, iprops, cprops);
}

export async function sendClientCompilationStageCompleteFact(stage: string, msSinceStart: number, startTs: number) {
    const cprops = [ClientType.WEBGL, getBrowserName(), stage];
    const iprops = [msSinceStart, startTs];

    return Stat.sendEvent(UserStatEntryType.client_compilation_stage_complete, DEFAULT_COUNT, iprops, cprops);
}

export async function sendFakeHardtutorFact() {
    return Stat.sendEvent(UserStatEntryType.client_first_click_experiment);
}

export async function sendMemoryAllocationErrorFact() {
    const cprops = [
        window.app.config.current_entry_point,
        getBrowserName(),
        String(RealCurrentUser.getInstance().getSuid())
    ];
    const iprops: number[] = [];

    return Stat.sendEvent(UserStatEntryType.client_memory_allocation_error, DEFAULT_COUNT, iprops, cprops);
}

export async function sendEnlargeMemoryArraysErrorFact() {
    const cprops = [
        window.app.config.current_entry_point,
        getBrowserName(),
        String(RealCurrentUser.getInstance().getSuid())
    ];
    const iprops: number[] = [];

    return Stat.sendEvent(UserStatEntryType.client_enlarge_memory_arrays_error, DEFAULT_COUNT, iprops, cprops);
}

export async function sendMemoryAccessOutOfBoundsErrorFact() {
    const cprops = [
        window.app.config.current_entry_point,
        getBrowserName(),
        String(RealCurrentUser.getInstance().getSuid())
    ];
    const iprops: number[] = [];

    return Stat.sendEvent(UserStatEntryType.client_memory_access_out_of_bounds_error, DEFAULT_COUNT, iprops, cprops);
}

export async function sendOutOfMemoryErrorFact() {
    const cprops = [
        window.app.config.current_entry_point,
        getBrowserName(),
        String(RealCurrentUser.getInstance().getSuid())
    ];
    const iprops: number[] = [];

    return Stat.sendEvent(UserStatEntryType.client_out_of_memory_error, DEFAULT_COUNT, iprops, cprops);
}

export async function sendCreateUnityInstanceFailedFact(message: string) {
    const errorMap = new Map<string, string>([
        ['Your browser does not support WebGL', 'webl_not_supported'],
        ['Your browser does not support WebAssembly', 'wasm_not_supported']
    ]);
    const errorType = errorMap.get(message) ||
        (/out of memory/i.test(message) ? 'out_of_memory' : 'other');
    const cprops = [
        window.app.config.current_entry_point,
        getBrowserName(),
        String(RealCurrentUser.getInstance().getSuid()),
        errorType
    ];
    const iprops: number[] = [];

    return Stat.sendEvent(UserStatEntryType.client_create_unity_instance_error, DEFAULT_COUNT, iprops, cprops);
}

export async function sendCommunityLinkClickFact() {
    const cprops = [
        'header'
    ];
    const iprops: number[] = [];
    return Stat.sendEvent(UserStatEntryType.client_community_link_click, DEFAULT_COUNT, iprops, cprops);
}

export async function sendFcmAccessNotifications(state: string) {
    const cprops = [
        state,
        getBrowserName(),
        RealCurrentUser.getInstance().getSuid()
            .toString()
    ];
    const iprops: number[] = [];
    return Stat.sendEvent(UserStatEntryType.client_fcm_notification_access, DEFAULT_COUNT, iprops, cprops);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function sendNewLoaderFact(factName: NewLoaderFacts): Promise<void|AxiosResponse<any>> {
    const userStatEntry = newLoaderClientFactsMap.get(factName);

    if (!userStatEntry) {
        return;
    }
    const cprops: string[] = [ClientType.WEBGL, getBrowserName()];
    const iprops: number[] = [];

    return Stat.sendEvent(userStatEntry, DEFAULT_COUNT, iprops, cprops);
}

export async function sendPaymentMethodChosenFact(paymentId: number, paymentMethod: string, paymentSubmethod?: string) {
    const cprops = [
        paymentMethod
    ];
    if (paymentSubmethod) {
        cprops.push(paymentSubmethod);
    }

    const iprops: number[] = [
        paymentId
    ];
    return Stat.sendEvent(UserStatEntryType.client_payment_method_chosen, DEFAULT_COUNT, iprops, cprops);
}

export async function sendPaymentProceedFact(paymentId: number, paymentMethod: string, transactionId: number) {
    const cprops = [
        paymentMethod
    ];

    const iprops: number[] = [
        paymentId,
        transactionId
    ];

    return Stat.sendEvent(UserStatEntryType.client_payment_proceed, DEFAULT_COUNT, iprops, cprops);
}
